// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__NalOl","wrapperSection":"styles_wrapperSection__girub","subtitle":"styles_subtitle__V3e3y"};